import { useContext, useEffect, useRef } from "react"
import '../../style/components/clientForm.css';
import { action } from "../../context/action";
import { switchh } from "../../context/switch";
import { mainSearch, update } from "../indexDB/indexDBStora";
import { useDebounce } from "../../funcs/hooks/useDebounce";
import { collection } from "../../context/collect";
import { intialData } from "../../context/initial";
import { useTranslation } from "react-i18next";

export default function ClientInfo(porps) {
    const { t } = useTranslation();
    const { setErrorMessage, errorMessage } = useContext(action);
    const { setEnableDelivery, setLoadingProcess, loadingProcess } = useContext(switchh)
    const { intialClient } = useContext(intialData);
    const {client, setClient} = useContext(collection);
    const loadingTriggered = useRef(false);

    const takesDataOfClient = async (e) => {
        e.preventDefault();
        if(!client.client_name || !client.address || !client.phone_number) {
            setErrorMessage("please write all information");
            return;
        }
        if(client.phone_number.length > 15) {
            setErrorMessage("your phone number is invalid");
            return;
        }
        setErrorMessage("");
        /*
        record the client in database to improve the UX of client
        ...
        */
        await update("clientinfo", client);
        setEnableDelivery(false);
    }
    const debounceSearchClient = useDebounce(client.phone_number,500);
    
    useEffect(() => {
        if(!client.phone_number && debounceSearchClient) return;
        const searchClient = async () => {
            const data = await mainSearch("clientinfo", debounceSearchClient);
            if(data) {
                setClient(
                    (prev) => (
                        {...prev,
                            client_name: data.client_name,
                            address: data.address,
                            mode: porps.mode,
                            details: {
                                floor: data.details.floor || "",
                                door: data.details.door || "", 
                                specialMark: data.details.specialMark || "",
                            },
                            payment: data.payment
                        }
                    )
                );
            }
            else {
                setClient(
                    (prev) => (
                        {
                            ...prev,
                            client_name: "",
                            address: "",
                            details: {
                                floor: "",
                                door: "", 
                                specialMark: ""
                            },
                            payment: 0
                        }
                    )
                );
            }
        }
        setLoadingProcess(false);
        loadingTriggered.current = false;
        searchClient();
    },[debounceSearchClient])

    const triggerLoadingOnce = (setLoadingProcess, loadingRef) => {
    if (!loadingRef.current) {
        setLoadingProcess(true);
        loadingRef.current = true;
    }
};
    return (
        <div className="client-info-container container-box fixed flex flex-center-center">
            <div className="box">
                <button onClick={()=> {
                    setEnableDelivery(false);
                    setClient(intialClient)
                }} className="close">x</button>
                <h2>{t("sections:CRM.sub.clientInfo")}</h2>
                <p>{loadingProcess && client.phone_number && t("common:searching")}</p>
                <form onSubmit={takesDataOfClient}>
                    <input type="text" placeholder={t("placeholder:CRM.clientName")} value={client.client_name} 
                    onChange={(e) => setClient((prev) => ({
                        ...prev, client_name: e.target.value
                    }))}  />
                    {/* filter numbers only without letters */}
                    <input
                        autoFocus
                        type="text"
                        placeholder={t("label:employee.phoneNumber")}
                        maxLength={15}
                        value={client.phone_number}
                        onChange={(e) => {
                            const value = e.target.value;

                            triggerLoadingOnce(setLoadingProcess, loadingTriggered);

                            if (/^[0-9]*$/.test(value)) {
                                setClient(prev => ({
                                    ...prev,
                                    phone_number: value
                                }));
                            }
                        }}
                    />
                    <input type="text" placeholder={t("label:employee.address")} value={client.address} 
                    onChange={(e) => setClient((prev) => ({
                        ...prev, address: e.target.value
                    }))}  />
                    <div className="details-address flex flex-space-bet">
                        <div>
                            <label>{t("label:CRM.sub.floor")}</label>
                            <input
                            value={client.details.floor}
                            onChange={(e) => setClient((prev) => ({
                                ...prev,
                                details: {...prev.details, floor: e.target.value}
                            }))}
                            type="text" placeholder={t("label:CRM.sub.floor")} />
                        </div>
                        <div>
                            <label>{t("label:CRM.sub.door")}</label>
                            <input
                            onChange={(e) => setClient((prev) => ({
                                ...prev,
                                details: {...prev.details, door: e.target.value}
                            }))}
                            value={client.details.door}
                            type="text" placeholder={t("label:CRM.sub.door")} />
                        </div>
                        <div>
                            <label>{t("label:CRM.sub.specialPlace")}</label>
                            <input
                            value={client.details.specialMark}
                            onChange={(e) => setClient((prev) => ({
                                ...prev,
                                details: {...prev.details, specialMark: e.target.value}
                            }))} 
                            type="text" placeholder={t("label:CRM.sub.specialPlace")}/>
                        </div>
                    </div>
                    <div>
                        <input 
                        onChange={(e) => {
                            const value = e.target.value;
                            if(/^[0-9]*$/.test(value)) {
                                setClient((prev) => ({
                                    ...prev,
                                    payment: value
                                })) 
                            }
                        }}
                        value={client.payment}
                        type="number" placeholder={t("placeholder:CRM.feesDelivery")} />
                    </div>
                    {errorMessage && 
                        <p className="error"><i className="fa-solid fa-circle-xmark"></i> {errorMessage}</p>
                    }
                    <div className="btn-client">
                        <button>{t("action:record")}</button>
                    </div>
                </form>
            </div>
        </div>
    )
}